import { Action, createReducer, on } from '@ngrx/store';
import { DbActionTypes, All } from './db.action';

export const initialState: any = {
  loading: false,
  result: null,
  errorState: null
};

export interface State {
  loading: boolean;
  result: any | null;
  errorState: string | null;
}

export function reducer(state = initialState, action: All): State {
  switch (action.type) {
    case DbActionTypes.Dbname_Request: {
      return {
        ...state,
        loading: true,
        result: null,
        errorState: null
      };
    }
    case DbActionTypes.Dbname_Failure: {
      return {
        ...state,
        loading: false,
        result: null,
        errorState: 'Failed to get dbs'
      };
    }
    case DbActionTypes.Dbname_Success: {
      return {
        ...state,
        loading: false,
        result: action.payload.dbs,
        errorState: null
      };
    }
    default: {
      return state;
    }
  }
}
